import { z } from 'zod';

import { blockSchema } from './blocks';

export const snippetBlocksSchema = z.array(blockSchema).min(1).max(20);

export const createSnippetSchema = z.object({
  name: z.string().min(1).max(120),
  description: z.string().max(300).optional(),
  category: z.string().max(40).optional(),
  blocks: snippetBlocksSchema,
});

export const updateSnippetSchema = z.object({
  name: z.string().min(1).max(120).optional(),
  description: z.string().max(300).nullable().optional(),
  category: z.string().max(40).nullable().optional(),
  blocks: snippetBlocksSchema.optional(),
});

export type CreateSnippetInput = z.infer<typeof createSnippetSchema>;
export type UpdateSnippetInput = z.infer<typeof updateSnippetSchema>;
export type SnippetBlocks = z.infer<typeof snippetBlocksSchema>;
